<div class="container" style="padding-left: 30px;">

    <div class="row">
        <div class="col-4">
            <mat-form-field appearance="fill">
                <mat-label>Select Month</mat-label>
                <mat-select [(value)]="currentMonth" (selectionChange)="changeMonth($event)" disableOptionCentering>
                  <mat-option *ngFor="let month of monthList" [value]="month.month">
                    {{month.title}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
        </div>
        <div class="col-4 gen-button">
            <button type="button" [disabled]="true" class="btn btn-primary">
                <div class="d-flex">
                    <span style="padding-right: 10px">Generate PDF (TODO)</span>
                    <!-- <mat-spinner *ngIf="saving" [diameter]="15"></mat-spinner> -->
                </div>
            </button>
        </div>
    </div>
    
      <table *ngIf="!!invoice" style="width:100%">
        <tr style="color: black;">
          <th>Order Id</th>
          <th style="text-align: right">Order Total</th>
          <th style="text-align: right">Delivery Fee</th>
          <th style="text-align: right">Processing Fee</th>
          <th style="text-align: right">Stripe Fee</th>
          <th style="text-align: right">Internal Fee</th>
          <th style="text-align: right">Internal Fee Percentage</th>
        </tr>
        <tr class="report-row" *ngFor="let invoiceLine of invoice.invoiceLines">
          <td>{{invoiceLine.orderId}}</td>
          <td style="text-align: right">£{{invoiceLine.orderAmount | number : '1.2-2'}}</td>
          <td style="text-align: right">£{{invoiceLine.deliveryFee | number : '1.2-2'}}</td>
          <td style="text-align: right">£{{invoiceLine.processingFee | number : '1.2-2'}}</td>
          <td style="text-align: right">£{{invoiceLine.stripeFee | number : '1.2-2'}}</td>
          <td style="text-align: right">£{{invoiceLine.internalFee | number : '1.2-2'}}</td>
          <td style="text-align: right">{{invoiceLine.internalFeePercentage}}%</td>
        </tr>
      </table>
      <br><br>
      <h2 *ngIf="!!invoice" style="float: right; color: black;">Invoice Total: £{{invoice.invoiceAmount | number : '1.2-2'}}</h2>

      <div *ngIf="loading" class="spinner-border">
    </div>
</div>